module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.2a6cc620.svg";